import { render, staticRenderFns } from "./adjustment-price-create.vue?vue&type=template&id=7a18bcbb&scoped=true"
import script from "./adjustment-price-create.vue?vue&type=script&lang=js"
export * from "./adjustment-price-create.vue?vue&type=script&lang=js"
import style0 from "./adjustment-price-create.vue?vue&type=style&index=0&id=7a18bcbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a18bcbb",
  null
  
)

export default component.exports